import { Audio, Sequence, staticFile } from "remotion";
import { Stage } from "../../coldcompute";
import { BLOCK } from "./constants";
import {
  SceneHook,
  SceneS1Setup,
  SceneS1Tension,
  SceneS1Broll,
  SceneS1OnScreen,
  SceneS1Payoff,
  SceneSeg2,
  SceneSeg3,
  SceneSeg4,
  SceneEndCard,
} from "./scenes";

// Ep 47 — first episode with a real recorded VO track. Each block's Sequence
// carries its own <Audio> clip (public/vo/47/); block durations in constants.ts
// are ceil(clipSeconds*30), so audio and visuals stay locked together.
export const AppsAreDyingReceipts: React.FC = () => (
  <Stage>
    <Sequence from={BLOCK.hook.start} durationInFrames={BLOCK.hook.duration}>
      <Audio src={staticFile("vo/47/hook.mp3")} />
      <SceneHook />
    </Sequence>
    <Sequence from={BLOCK.s1setup.start} durationInFrames={BLOCK.s1setup.duration}>
      <Audio src={staticFile("vo/47/s1-setup.mp3")} />
      <SceneS1Setup />
    </Sequence>
    <Sequence from={BLOCK.s1tension.start} durationInFrames={BLOCK.s1tension.duration}>
      <Audio src={staticFile("vo/47/s1-tension.mp3")} />
      <SceneS1Tension />
    </Sequence>
    <Sequence from={BLOCK.s1broll.start} durationInFrames={BLOCK.s1broll.duration}>
      <Audio src={staticFile("vo/47/s1-broll.mp3")} />
      <SceneS1Broll />
    </Sequence>
    <Sequence from={BLOCK.s1onscreen.start} durationInFrames={BLOCK.s1onscreen.duration}>
      <Audio src={staticFile("vo/47/s1-onscreen.mp3")} />
      <SceneS1OnScreen />
    </Sequence>
    <Sequence from={BLOCK.s1payoff.start} durationInFrames={BLOCK.s1payoff.duration}>
      <Audio src={staticFile("vo/47/s1-payoff.mp3")} />
      <SceneS1Payoff />
    </Sequence>
    <Sequence from={BLOCK.seg2.start} durationInFrames={BLOCK.seg2.duration}>
      <Audio src={staticFile("vo/47/seg2.mp3")} />
      <SceneSeg2 />
    </Sequence>
    <Sequence from={BLOCK.seg3.start} durationInFrames={BLOCK.seg3.duration}>
      <Audio src={staticFile("vo/47/seg3.mp3")} />
      <SceneSeg3 />
    </Sequence>
    <Sequence from={BLOCK.seg4.start} durationInFrames={BLOCK.seg4.duration}>
      <Audio src={staticFile("vo/47/seg4.mp3")} />
      <SceneSeg4 />
    </Sequence>
    <Sequence from={BLOCK.endcard.start} durationInFrames={BLOCK.endcard.duration}>
      {/* CTA VO not recorded yet — see the end card's placeholder */}
      <SceneEndCard />
    </Sequence>
  </Stage>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
